module.exports = __webpack_public_path__ + "static/media/icon_delete.ca5d19bc.svg";